import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { useTheme as useGlubesTheme } from '../../context/ThemeContext';
import { createGlubesMuiTheme } from '../../theme/createGlubesMuiTheme';

interface GlubesMuiThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Syncs MUI theme mode with {@link ThemeContext} (light / dark / system).
 * Must render inside the app `ThemeProvider` from `ThemeContext`.
 */
export default function GlubesMuiThemeProvider({ children }: GlubesMuiThemeProviderProps) {
  const { resolvedTheme, primaryMainLight, primaryMainDark } = useGlubesTheme();
  const theme = useMemo(
    () =>
      createGlubesMuiTheme(resolvedTheme, {
        primaryMainLight,
        primaryMainDark,
      }),
    [resolvedTheme, primaryMainLight, primaryMainDark]
  );

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
